(() => {
  // Só desktop com mouse (evita dor de cabeça no touch)
  const isHoverDevice = () =>
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  const init = () => {
    if (!isHoverDevice()) return;

    // Dawn costuma usar header-menu > details
    const menus = document.querySelectorAll(
      ".header__inline-menu header-menu details, .header__inline-menu details-disclosure details"
    );

    menus.forEach((details) => {
      // Abre quando passa o mouse
      details.addEventListener("mouseenter", () => {
        details.setAttribute("open", "");
      });

      // Fecha quando sai do item (com pequeno delay pra evitar “piscar”)
      let closeTimer;
      details.addEventListener("mouseleave", () => {
        closeTimer = setTimeout(() => {
          details.removeAttribute("open");
        }, 120);
      });

      details.addEventListener("mouseenter", () => {
        if (closeTimer) clearTimeout(closeTimer);
      });

      // Se clicar num link dentro, fecha o menu (opcional, mas deixa mais “limpo”)
      details.querySelectorAll("a").forEach((a) => {
        a.addEventListener("click", () => details.removeAttribute("open"));
      });
    });

    // Fecha se clicar fora do header
    document.addEventListener("click", (e) => {
      if (e.target.closest(".header__inline-menu")) return;
      document
        .querySelectorAll(".header__inline-menu details[open]")
        .forEach((d) => d.removeAttribute("open"));
    });
  };

  // Dawn usa section rendering; init em load + Shopify events
  window.addEventListener("load", init);
  document.addEventListener("shopify:section:load", init);
})();